




































import type {
  Field,
  PricingTableCurrencySettings,
  PricingTableSection,
  PricingTableSummaryValues,
} from '@getaccept/editor-lib';
import {
  PricingTableHelper,
  getTotalDiscount,
  getTotalDiscountIsEmpty,
  getTotalTax,
  getTotalTaxIsEmpty,
  getTotalPriceValue,
} from '@getaccept/editor-lib';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'PricingTablePriceSummary',
  props: {
    summaryValues: { type: Object as PropType<PricingTableSummaryValues>, default: () => ({}) },
    currencySettings: {
      type: Object as PropType<PricingTableCurrencySettings>,
      default: () => ({}),
    },
    isPreCalculated: { type: Boolean },
    sections: { type: Array as PropType<PricingTableSection[]>, default: () => [] },
    fields: { type: Array as PropType<Field[]>, default: () => [] },
  },
  setup(props) {
    const getTotalTaxValue = computed(() => {
      if (getTotalTaxIsEmpty(props.summaryValues)) {
        return '';
      }
      return getTotalTax(
        props.summaryValues,
        props.currencySettings,
        props.isPreCalculated,
        props.sections,
        props.fields
      );
    });

    const getTotalDiscountValue = computed(() => {
      if (getTotalDiscountIsEmpty(props.summaryValues)) {
        return '';
      }
      return getTotalDiscount(
        props.summaryValues,
        props.currencySettings,
        props.isPreCalculated,
        props.sections,
        props.fields
      );
    });

    return {
      getTotalTaxValue,
      getTotalDiscountValue,
      currencyFormat: PricingTableHelper.currencyFormat,
      getTotalTaxIsEmpty,
      getTotalDiscountIsEmpty,
      getTotalPriceValue,
    };
  },
});
